import { Injectable } from '@angular/core';
import { MedicoController } from 'app/controllers/grl/medico.controller';
import { MedicoDTO } from 'app/model/dtos/grl/medico.dto';
import { LoaderService } from '../loader.service';
import { MedicoSearch } from './medico.search';


@Injectable()
export class MedicoService{

    constructor(
        private _medicoController: MedicoController,
        private _loaderService: LoaderService
    ){}

    async find(medicoSearch?:MedicoSearch): Promise<MedicoDTO[]>{
        try{return await this._medicoController.find(medicoSearch && medicoSearch.getFilters() || null);}
        catch(error){return [];}
    }

    async get(cdPessoa:number):Promise<any>{
        this._loaderService.show();
        return await this._medicoController.get(cdPessoa).finally(() => this._loaderService.hide());
    }
    
    async getAll():Promise<MedicoDTO[]>{
        this._loaderService.show();
        return this._medicoController.find().finally(() => this._loaderService.hide());
    }

    async save( medicoDTO: MedicoDTO ):Promise< MedicoDTO > {
        this._loaderService.show();
        if( medicoDTO.cdPessoa && medicoDTO.cdPessoa > 0 ) {

            return this._medicoController.update( medicoDTO ).finally( () => this._loaderService.hide() );
        } else {
            return this._medicoController.create( medicoDTO ).finally( () => this._loaderService.hide() );
        }
    }

}